import { gql } from '../../../apollo/__generated__';

export const EVENT_USERS = gql(`
  query EventUsers($eventId: ID!, $hasPaid: Boolean) {
    eventUsers(eventId: $eventId, hasPaid: $hasPaid) {
      id
      firstname
      lastname
      nickname
      email
      folklore
      studyTown
      studies
      isValidated(eventId: $eventId)
    }
  }
`);
